import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const coder = defineConnector({
  identifier: "coder",
  name: "Coder",
  tagLine: "Cloud development environments",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://.*.coder.com/.*",
  auth: (app) =>
    headerAuth([{ name: "Coder-Session-Token", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Enter your Coder instance URL",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "coder.your-company.com",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Create a session token",
      items: [
        {
          kind: "markdown",
          content:
            "In Coder, go to your **Account › Tokens** and create a new API token. See the [API docs](https://coder.com/docs/reference/api) for details.",
        },
        {
          kind: "input",
          label: "Session token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/v2/users/me`,
  },
});
